import { Tooltip } from '@material-ui/core';
import { useEffect } from 'react';
import { useUploaderBl } from './hooks/useUploaderBl';
import styles from './Uploader.module.css';
import { useDispatch } from 'react-redux';
import { resetErrorCount } from 'redux/slices/UploadSlice';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useTranslation } from 'react-i18next';
const Uploader = ({ group, fetchProducts, products, disabled, isDemo }) => {
  const { fileInputRef, handleInputClick, handleFileUpload } = useUploaderBl();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(resetErrorCount());
  }, [group, dispatch]);

  return (
    <div className={styles.mainContainer}>
      {disabled ? (
        <Tooltip
          title={
            // isDemo
            //   ? 'Elérted demo galériád képfeltöltési limitjét! Ha több képet szeretnél feltölteni, élesítsd boltodat!'
            //   :
            t('uploader.disabledTooltip')
          }>
          <div className={styles.uploadButton} onClick={() => {}}>
            <CloudUploadIcon className={styles.uploadIcon} />
            <p className={styles.uploadText}>{t('uploader.disabled')}</p>
          </div>
        </Tooltip>
      ) : (
        <div className={styles.uploadButton} onClick={handleInputClick}>
          <CloudUploadIcon className={styles.uploadIcon} />
          <p className={styles.uploadText}>{t('uploader.upload')}</p>
        </div>
      )}
      <input
        ref={fileInputRef}
        hidden
        type='file'
        accept='.jpg, .jpeg'
        onChange={(e) => {
          handleFileUpload(e, group?.id, group?.modifiers, fetchProducts, products);
        }}
        multiple
      />
    </div>
  );
};

export default Uploader;
